export const setElementCSS = (element, value) => {
  const domElement = element;
  if (domElement) domElement.style.cssText += value;
};

export const setSelctorCSS = (container, selector, value) => {
  const elements = container.querySelectorAll(selector);
  [...elements].forEach(itm => setElementCSS(itm, value));
};

export const setElementStyle = (element, property, value) => {
  const domElement = element;
  if (domElement) domElement.style[property] = value;
};

export const setSelctorStyle = (container, selector, property, value) => {
  const domcontainer = container;
  const elements = domcontainer.querySelectorAll(selector);
  [...elements].forEach(itm => itm.style.setProperty(property, value));
};

export const setSelctorStyleImportant = (container, selector, property, value) => {
  const domcontainer = container;
  const elements = domcontainer.querySelectorAll(selector);
  [...elements].forEach(itm => itm.style.setProperty(property, value, 'important'));
};

export const setElementStyleImportant = (element, property, value) => {
  const domElement = element;
  if (domElement) domElement.style.setProperty(property, value, 'important');
};



// WEBPACK FOOTER //
// ./app/javascript/renderer/domOperations/styleOperations.js